import styled from 'styled-components';
import Button from '@material-ui/core/Button';

import Card from '../../../components/Card/Card';
import { THEME } from '../../../constants';

export const CardWrapper = styled(Card)`
  margin-top: 10px !important;
  max-width: 872px;
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const CustomerPaymentContainer = styled.div`
  border-bottom: 1px solid ${THEME.lightGrey};
  display: flex;
  flex-direction: row;
  padding: 40px;
  justify-content: center;
  gap: 50px;
  flex-wrap: wrap;
`;

export const Footer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin: 21px 0 10px 0;
`;

export const InvoiceButton = styled(Button)`
  border-radius: 8px !important;
  color: ${THEME.primary} !important;
  font-family: Montserrat !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.14 !important;
  letter-spacing: 1.5px !important;
  min-height: 40px;
  padding: 12px 16px
`;

export const Margin = styled.div`
  flex: 1;
`;

export const PaymentLinkContainer = styled.div`
  color: ${THEME.grey};
  margin-right: 10px;
  text-align: center;
  user-select: none;
  width: 100%;
`;

export const PaymentLink = styled.a`
  color: ${THEME.grey};
  cursor: pointer;
  display: inline;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;  
  margin: 0;
  text-decoration: underline;
`;

PaymentLink.displayName = 'PaymentLink';
